MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');
  var ENABLED_BREAKPOINT = 860;

  MS.sultrysalt_persistent_bar = {

    init: function () {

      this.$element = $('.ms-ss_module-persistent-bar');
      this.$player = this.$element.find('#ms-ss_module-persistent-bar__video-player');
      this.enabled = false;
      this.playing = false;

      // Initialize player only if there is a recipe player in the hero
      if ( MS.sultrysalt_hero.$recipeVideo.length && MS.sultrysalt_hero.recipeVideoID ) {
        this.initializePlayer();
      }
    },


    // Initialize player in preparation only
    initializePlayer: function () {
      var _this = this;

     if (typeof(YT) === 'undefined' || typeof(YT.Player) === 'undefined') {
        window.onYouTubePlayerAPIReady = function () {
          _this.onYTPlayerAPIReady();
        };
      } else {
        _this.onYTPlayerAPIReady();
      }
    },


    onYTPlayerAPIReady: function () {
      this.player = new YT.Player(this.$player[0].id, {
        playerVars: {
          autoplay: 0,
          autohide: 1,
          modestbranding: 0,
          rel: 0,
          showinfo: 0,
          controls: 0,
          disablekb: 1,
          enablejsapi: 0,
          iv_load_policy: 3,
          playsinline: 1,
        },
        events: {
          'onReady': this.onPlayerReady.bind(this),
          'onStateChange': this.onPlayerStateChange.bind(this)
        }
      });
    },


    // Fires when player is instantiated and ready
    onPlayerReady: function () {

      // By this time, our player DIV should already be replaced with iframe,
      // So we need to re-query it
      this.$player = this.$element.find('#ms-ss_module-persistent-bar__video-player');

      this.loadRecipeVideo();
      this.updateMetrics();
      this.bindResize();
      this.bindScroll();

      // Initial call
      this.checkForPlayerBehaviour();
    },


    // Loads the video for buffering only
    loadRecipeVideo: function () {

      // Build video parameters
      var RECIPE_OBJ = {
        videoId: MS.sultrysalt_hero.recipeVideoID,
        suggestedQuality: 'hd480'
      };

      // Load video
      this.player.cueVideoById(RECIPE_OBJ);
      this.player.mute();
    },


    // Pause recipe video, play persistent video at recipe video's last frame
    play: function () {

      if ( this.playing || !MS.sultrysalt_hero.recipePlayer ) {
        return;
      }

      var currentTime = MS.sultrysalt_hero.RECIPE_VIDEO_OFFSET;

      // Pause recipe video
      if ( MS.sultrysalt_hero.recipePlayer && MS.sultrysalt_hero.recipePlayer.pauseVideo ) {
        console.log('recipe player paused by persistent bar');
        MS.sultrysalt_hero.recipePlayer.pauseVideo();
        currentTime = MS.sultrysalt_hero.recipePlayer.getCurrentTime();
      }

      // Flag player
      this.playing = true;

      if ( currentTime ) {
        this.player.seekTo(currentTime);
      }

      this.player.playVideo();
    },


    // Pause persistent video, play recipe video at persistent video's last frame
    pause: function () {

      if ( !this.playing || !MS.sultrysalt_hero.recipePlayer ) {
        return;
      }

      // Pause recipe video
      this.player.pauseVideo();

      // Flag player
      this.playing = false;

      // Get currentTime
      var currentTime = this.player.getCurrentTime();

      if ( MS.sultrysalt_hero.recipePlayer ) {
        console.log('recipe player played by persistent bar');
        MS.sultrysalt_hero.recipePlayer.seekTo(currentTime);
        MS.sultrysalt_hero.recipePlayer.playVideo();
      }
    },


    // Listen on player state change
    onPlayerStateChange: function (e) {
      var that = this;

      if ( e.data === 0 ) {

        this.player.playing = false;

        if ( MS.sultrysalt_hero.recipePlayer && MS.sultrysalt_hero.recipePlayer.seekTo ) {
          MS.sultrysalt_hero.endRecipeVideo();
        }

        // End video
        this.videoFinished = true;
        this.player.seekTo(MS.sultrysalt_hero.RECIPE_VIDEO_OFFSET);
        this.player.pauseVideo();

        setTimeout(function () {
          that.$element.attr('data-visible', true);
        }, 100);

      } else if ( e.data === 1 ) {
        this.player.playing = true;
        this.$element.attr('data-visible', true);
        this.videoFinished = false;
        MS.sultrysalt_hero.recipeVideoFinished = false;
      } else {
        this.player.playing = false;
        this.$element.removeAttr('data-visible');
      }
    },


    // Computes essential metrics and save
    updateMetrics: function () {
      // The component height
      this.height = this.$element.height();

      // The player height
      this.playerHeight = this.$player.outerHeight();

      // The component top offset. Use parent as basis, if ever the component is in fixed state
      this.offsetTop = this.$element.parent().offset().top;

      // Computes for triggering scroll amount. At which scroll amount should the player play/pause
      // Current setting is at the player's whole height
      this.scrollAmountTrigger = this.offsetTop - window.innerHeight + this.playerHeight;

      // Check whether to enable or disable according to breakpoint
      if ( window.innerWidth >= ENABLED_BREAKPOINT ) {
        this.enabled = true;
      } else {
        this.enabled = false;
        this.pause();
      }
    },


    // Listen to resize event
    bindResize: function () {
      var _this = this;

      $window.on('resize', function () {
        _this.updateMetrics();
      });
    },


    // Listen to scroll
    bindScroll: function () {
      var _this = this;

      $window.on('scroll', function () {
        _this.checkForPlayerBehaviour();
      });
    },


    // Checks for current position of component in viewport
    // Checks whether to start or stop player
    checkForPlayerBehaviour: function () {
      var currentScroll = window.pageYOffset;

      if ( !this.enabled || MS.sultrysalt_hero.recipeVideoFinished ) {
        return;
      }

      if ( currentScroll > this.scrollAmountTrigger ) {
        this.atPlayableScroll = true;
        this.play();
      } else {
        this.atPlayableScroll = false;
        this.pause();
      }
    },


  };
})(jQuery);
